import React from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import Login from "./Auth/Login";
// import Logout from "./Auth/Logout";
// import ResetPassword from "./ResetPassword/ResetPassword";
import Dashboard from "./Dashboard/Dashboard";
// import ProtectedRoute from "./Router/ProtectedRoute";

const App = props => {
  return (
    <Login>
      <AuthenticatedTemplate>
        {props.user ? (
          <Router>
            <Dashboard />
          </Router>
        ) : (
          <p>Please sign in!</p>
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div></div>
      </UnauthenticatedTemplate>
    </Login>
  );
};

const mapStateToProps = state => {
  return {
    user: state.authReducer.user,
  };
};

export default connect(mapStateToProps, {})(App);
